import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class StripePersonService {
  static async update({ id, stripePersonId, propertyId, subpropertyId, personToken, phone }) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPEPERSON_UPDATE(
          $id: String!
          $stripePersonId: String!
          $propertyId: String!
          $subpropertyId: String!
          $personToken: String!
          $phone: PhoneInput!
        ) {
          stripePersonUpdate(id: $id, stripePersonId: $stripePersonId, propertyId: $propertyId, subpropertyId: $subpropertyId, personToken: $personToken, phone: $phone) {
            id
          }
        }
      `,

      variables: {
        id,
        stripePersonId,
        propertyId,
        subpropertyId,
        personToken,
        phone,
      },
    });

    return response.data.stripePersonUpdate;
  }

  static async create({ propertyId, subpropertyId, personToken, phone }) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPEPERSON_CREATE(
          $propertyId: String!
          $subpropertyId: String!
          $personToken: String!
          $phone: PhoneInput!
        ) {
          stripePersonCreate(propertyId: $propertyId, subpropertyId: $subpropertyId, personToken: $personToken, phone: $phone) {
            id
          }
        }
      `,

      variables: {
        propertyId,
        subpropertyId,
        personToken,
        phone,
      },
    });

    return response.data.stripePersonCreate;
  }

  static async find(id, propertyId, connectedAccountId) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPEPERSON_FIND(
          $id: String!
          $propertyId: String!
          $connectedAccountId: String!
        ) {
          stripePersonFind(id: $id, propertyId: $propertyId, connectedAccountId: $connectedAccountId) {
            id
            email
            relationship {
              accountOpener
              director
              executive
              owner
              percentOwnership
              title
            }
            firstName
            lastName
            address {
              line1
              line2
              city
              postalCode
              state
              country
            }
            ssnLast4Provided
            created
            phone {
              prefix
              number
            }
            requirements {
              currentlyDue
              eventuallyDue
              pastDue
              pendingVerification
            }
            verification {
              details
              detailsCode
              document {
                front
                back
                details
                detailsCode
              }
              additionalDocument {
                front
                back
              }
              status
            }
            birthdate {
              day
              month
              year
            }
            stripePersonId
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        propertyId,
        connectedAccountId,
      },
    });

    const record = {
      ...response.data.stripePersonFind,
      jobTitle: response.data.stripePersonFind.relationship.title,
      isOwner: response.data.stripePersonFind.relationship.owner || false,
      isAccountOpener: response.data.stripePersonFind.relationship.accountOpener || false,
      isExecutive: response.data.stripePersonFind.relationship.executive || false,
      isDirector: response.data.stripePersonFind.relationship.director || false,
      ownershipPercentage: response.data.stripePersonFind.relationship.percentOwnership,
    };

    delete record.ssnLast4;

    return record;
  }

  static async list(propertyId, connectedAccountId, filter, limit, offset, orderBy) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPEPERSON_LIST(
          $propertyId: String!, 
          $connectedAccountId: String!,
          $filter: StripePersonFilterInput,
          $limit: Int,
          $offset: Int,
          $orderBy: StripePersonOrderByEnum
        ) {
          stripePersonList(
            propertyId: $propertyId
            connectedAccountId: $connectedAccountId
            filter: $filter
            limit: $limit
            offset: $offset
            orderBy: $orderBy
          ) {
            count
            rows {
              id
              firstName
              lastName
              phone {
                prefix
                number
              }
              email
              verification {
                status
              }
              requirements {
                currentlyDue
                eventuallyDue
                pastDue
                pendingVerification
              }
              relationship {
                accountOpener
                director
                executive
                owner
                percentOwnership
                title
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        propertyId,
        connectedAccountId,
        filter,
        limit,
        offset,
        orderBy,
      },
    });

    return response.data.stripePersonList;
  }
}
